module.exports = __webpack_public_path__ + "img/8.BMW2019.62e4bb02.png";